<template>
    <module-card :nextDisabled="nextDisabled" ref="moduleCard">
        <p>Why should P be concerned about ignoring his BottomLine? Select all that apply.</p>

        <div v-for="choice in choices" :key="choice.id" class="grey pa-3 mb-1 response" :class="{ 'lighten-3': !choice.selected }" @click.stop="select(choice)" v-ripple>
            <span :class="{ 'incorrect-selected': isIncorrectAlreadySelected(choice) }">{{ choice.text }}</span>
        </div>

        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </module-card>
</template>

<script>
    import { every, includes } from 'lodash';
    export default {
        data() {
            return {
                incorrectSelected: [],
                choices: [
                    {
                        id: 1,
                        text: `P shouldn’t be concerned about ignoring his BottomLine`,
                        selected: false,
                        correct: false,
                        feedback: `Why not? Try again.`
                    },
                    {
                        id: 2,
                        text: `P is having sex without a condom, putting himself at risk for HIV`,
                        selected: false,
                        correct: true,
                        feedback: `That's correct! Anything else?`
                    },
                    {
                        id: 3,
                        text: `P doesn’t know his relationship status – if his boo is having condomless sex with other guys too`,
                        selected: false,
                        correct: true,
                        feedback: `That's correct! Anything else?`
                    },
                    {
                        id: 4,
                        text: `P doesn’t know the health status of his new boo`,
                        selected: false,
                        correct: true,
                        feedback: `That's correct! Anything else?`
                    }
                ],
                allCorrectFeedback: `Yep! You've selected all of the correct answers!`
            };
        },
        methods: {
            nextDisabled() {
                // disable next until all correct choices have been selected
                return !every(this.choices, (c) => {
                    return (c.selected && c.correct) || !c.correct;
                });
            },
            select(choice) {
                // if all correct choices have been selected, move forward automatically
                if (
                    choice.correct &&
                    every(this.choices, (c) => {
                        return (c.selected && c.correct) || !c.correct || c === choice;
                    })
                ) {
                    this.$refs.modalFeedback.show(choice.correct, this.allCorrectFeedback, () => {
                        choice.selected = true;
                        this.$refs.moduleCard.nextClick();
                    });
                } else {
                    this.$refs.modalFeedback.show(choice.correct, choice.feedback, () => {
                        if (choice.correct) {
                            choice.selected = true;
                        } else {
                            // add the choice to incorrectSelected if it doesn't already include it
                            if (!includes(this.incorrectSelected, choice.id)) {
                                this.incorrectSelected.push(choice.id);
                            }
                        }
                    });
                }
            },
            isIncorrectAlreadySelected(choice) {
                return this.incorrectSelected.includes(choice.id);
            }
        }
    };
</script>

<style scoped>
    .incorrect-selected {
        text-decoration: line-through;
        text-decoration-color: red;
    }
</style>
